import { createStore } from './storeFactory';
import { initialGlobalState } from './initialGlobalState';

export const useStore = createStore(initialGlobalState);
